import { create } from 'zustand'

interface FilterState {
  // Global date range
  dateFrom: string | null
  dateTo: string | null
  setDateRange: (from: string | null, to: string | null) => void

  // Tenant filter (for cross-module filtering)
  tenantId: string | null
  setTenantId: (id: string | null) => void

  // Sidebar collapsed
  sidebarCollapsed: boolean
  toggleSidebar: () => void

  // Reset
  resetFilters: () => void
}

export const useFilterStore = create<FilterState>((set) => ({
  dateFrom: null,
  dateTo: null,
  setDateRange: (from, to) => set({ dateFrom: from, dateTo: to }),

  tenantId: null,
  setTenantId: (id) => set({ tenantId: id }),

  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  resetFilters: () => set({ dateFrom: null, dateTo: null, tenantId: null }),
}))
